import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Switch } from '@mui/material';
import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AdiantamentoService } from '../../../shared/services/api/AdiantamentoService';
import RelatorioAdiantamento from './RAdiantamento';

export const RAdiantamento: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [datainicial, setDataIncial] = useState<Dayjs | null>(dayjs());
  const [datafinal, setDataFinal] = useState<Dayjs | null>(dayjs());
  const [openmsg, setOpenmsg] = useState(false);
  const [checked, setChecked] = useState(true);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (   
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;                  
    }          
    setOpenmsg(false);                       
  };                          
              
  const handleRelatorio = () => {   
    AdiantamentoService                 
      .Relatorio(dayjs(datainicial).format('DD/MM/YYYY'), dayjs(datafinal).format('DD/MM/YYYY'), checked)   
      .then((result) => {            
        setIsLoading(false);                 
        if (result instanceof Error) {                         
          setTms('error');           
          setMsg(result.message);      
          setOpenmsg(true);                                   
        }else {        
          if(result.length > 0){   
            RelatorioAdiantamento(result, checked, `Período: ${dayjs(datainicial).format('DD/MM/YYYY')} a  ${dayjs(datafinal).format('DD/MM/YYYY')}`);  
          }else{
            setTms('warning');
            setMsg('Nenhum registro encontrado');
            setOpenmsg(true);  
          }
        }                
      });      
  };  

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} display="flex" alignItems="center" alignSelf='center' margin={1} alignContent='center'></Box>
      <Box width='auto' alignItems="center" component={Paper} height="auto" margin={1}
        alignContent='center'>
        <DialogTitle>Relatório de Adiantamento</DialogTitle>
        <DialogContent  dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
          <Grid marginTop={2} item>
              <LocalizationProvider  dateAdapter={AdapterDayjs}>
                <DatePicker
                  format='DD/MM/YYYY'
                  value={datainicial}
                  onChange={(newValue) => setDataIncial(newValue)}
                  label='Data Inicial'
                  slotProps={{
                    textField: {
                      size: 'small',
                    }    
                  }}   
                />
              </LocalizationProvider>   
               <LocalizationProvider  dateAdapter={AdapterDayjs}>
                <DatePicker
                  sx={{marginLeft: 2}}
                  format='DD/MM/YYYY'
                  value={datafinal}
                  onChange={(newValue) => setDataFinal(newValue)}
                  label='Data Final'
                  slotProps={{
                    textField: {
                      size: 'small',
                    }
                  }}
                />
              </LocalizationProvider>  
           </Grid>         
           <Grid marginTop={2} item>   
            <FormControlLabel
                  control={
                    <Switch
                      checked={checked}
                      onChange={e => {setChecked(e.target.checked)}}
                      color="primary"
                      defaultChecked
                    />
                  } 
                  label = {'Descontar'}
                />
           </Grid>     
        </DialogContent>
        <DialogActions>
          <Button variant='contained' autoFocus onClick={handleRelatorio}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   